import { SIDE_PANEL_MAX_WIDTH, SIDE_PANEL_MIN_WIDTH } from "defs";

export const clampWidth = (width: number): number =>
  Math.round(
    Math.min(SIDE_PANEL_MAX_WIDTH, Math.max(SIDE_PANEL_MIN_WIDTH, width)),
  );
